import { render } from "./GetZXZBPage.vue?vue&type=template&id=4928be0f&scoped=true"
import script from "./GetZXZBPage.vue?vue&type=script&lang=js"
export * from "./GetZXZBPage.vue?vue&type=script&lang=js"

import "./GetZXZBPage.vue?vue&type=style&index=0&id=4928be0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4928be0f"]])

export default __exports__